import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { DataTable } from "./partial/DataTable"
import { columns } from "./partial/Columns"

const getListKelompokVerifikasiPesertaButawarna = async (
  id_verbutawarna_rekap: string
) => {
  const response = await api.get(
    `/setting/verifikator-butawarna/show-kelompok/${id_verbutawarna_rekap}`,
    {
      withCredentials: true,
    }
  )
  return response.data
}

export default function SettingVerifikatorButawarnaDetailPage() {
  const [searchParams] = useSearchParams()
  const idVerButawarnaRekap = searchParams.get("id")

  const { data, isPending } = useQuery({
    queryKey: ["listKelompokVerifikasiPesertaButawarna", idVerButawarnaRekap],
    queryFn: () =>
      getListKelompokVerifikasiPesertaButawarna(String(idVerButawarnaRekap)),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  )
}
